import { LANGUAGE } from "@root/constants";
import { getCurrentLanguage } from "@root/store/selectors/features";
import { updateLanguage } from "@root/store/slices/features";
import { changeAppLanguage } from "@root/utils/change-language";
import { useDispatch, useSelector } from "react-redux";

function useLanguage() {
  const currentLanguage = useSelector(getCurrentLanguage);
  const dispatch = useDispatch();

  const handleUpdateLanguage = (language: any) => {
    changeAppLanguage(language);
    dispatch(updateLanguage(language));
  };

  const toggleLanguage = () => {
    handleUpdateLanguage(
      currentLanguage === LANGUAGE.ENGLISH ? LANGUAGE.KOREAN : LANGUAGE.ENGLISH
    );
  };

  return {
    toggleLanguage,
    handleUpdateLanguage,
    currentLanguage,
    IsEnglishLanguage: currentLanguage === "EN",
  };
}

export default useLanguage;
